import React from 'react';
import { Clock, FileQuestion } from 'lucide-react';

const categoryBadgeClass = {
  Azure: 'exam-dashboard__badge exam-dashboard__badge--azure',
  AWS: 'exam-dashboard__badge exam-dashboard__badge--aws',
  Linux: 'exam-dashboard__badge exam-dashboard__badge--linux',
  General: 'exam-dashboard__badge exam-dashboard__badge--general',
};

const difficultyBadgeClass = {
  Associate: 'exam-dashboard__badge exam-dashboard__badge--associate',
  Expert: 'exam-dashboard__badge exam-dashboard__badge--expert',
};

/**
 * Exam card for the learning dashboard.
 */
function ExamLearningCard({ exam, attempt, onStartExam }) {
  const title = exam.codigo || exam.titulo || 'Exam';
  const desc = exam.descripcion || 'Question set (multiple choice).';
  const cat = exam.category || 'General';
  const diff = exam.difficulty || 'Associate';
  const catCls = categoryBadgeClass[cat] || categoryBadgeClass.General;
  const diffCls = difficultyBadgeClass[diff] || difficultyBadgeClass.Associate;

  return (
    <article className="exam-dashboard__card">
      <div className="exam-dashboard__card-header">
        <h2 className="exam-dashboard__card-title">{title}</h2>
        <div className="exam-dashboard__badges">
          <span className={catCls}>{cat}</span>
          <span className={diffCls}>{diff}</span>
        </div>
      </div>

      <p className="exam-dashboard__card-desc">{desc}</p>

      {attempt ? (
        <div className="exam-dashboard__progress">
          <div className="exam-dashboard__progress-head">
            <span>Last score</span>
            <span className="exam-dashboard__progress-score">{attempt.scorePercent}%</span>
          </div>
          <div className="exam-dashboard__progress-track">
            <div
              className="exam-dashboard__progress-fill"
              style={{ width: `${Math.min(100, attempt.scorePercent)}%` }}
            />
          </div>
        </div>
      ) : null}

      <div className="exam-dashboard__card-footer">
        <div className="exam-dashboard__meta">
          <span className="exam-dashboard__meta-item">
            <FileQuestion className="h-4 w-4" aria-hidden />
            <span>
              <span className="exam-dashboard__meta-strong">{exam.questionCount}</span> questions
            </span>
          </span>
          <span className="exam-dashboard__meta-item">
            <Clock className="h-4 w-4" aria-hidden />
            <span>
              ~<span className="exam-dashboard__meta-strong">{exam.estimatedMinutes}</span> min
            </span>
          </span>
        </div>
        <button type="button" onClick={() => onStartExam(exam.id)} className="exam-dashboard__btn-start">
          Start Exam
        </button>
      </div>
    </article>
  );
}

export default ExamLearningCard;
